import React, { useEffect } from "react";
import UserPermission from "../../Components/UserPermission/UserPermission";
import "./UserPermissions.scss";

import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import {
  updateUserPermission,
  userPermissionRowsList,
  clearUserPermissionRows,
} from "../../Redux/Slices/UserPermission/UserPermissionRowsSlicer";
import { useSearchParams } from "react-router-dom";
import { listRole } from "../../Redux/Slices/Role/ListRoleSlice";
import Snackbar from "../../Components/Snackbar/Snackbar";
import { listSideMenuPermission } from "../../Redux/Slices/SideMenuPermission/ListSideMenuPermissionSlice";
import { listYearlevel_map } from "../../Redux/Slices/Yearlevel_map/ListYearlevel_mapSlice";
import { cleareditUserPermission } from "../../Redux/Slices/UserPermission/UpdateUserPermissionSlicer";

const UserPermissions: React.FC = () => {
  const dispatch = useAppDispatch();
  const permissionData = useAppSelector((state) => state.ListRoleSlice);
  const userPermissionRowsData = useAppSelector(
    (state) => state.UserPermissionRows
  );
  const userPermissionRowsDataUpdate = useAppSelector(
    (state) => state.EditUserPermission
  );
  const { data: listYearlevel_maps } = useAppSelector(
    (state) => state.ListYearlevel_mapSlice
  );
  const [searchParams] = useSearchParams();

  useEffect(() => {
    dispatch(listRole());
    dispatch(listYearlevel_map());
    // dispatch(listSideMenuPermission());
    dispatch(userPermissionRowsList(searchParams.get("id")));
  }, [dispatch, searchParams]);

  useEffect(() => {
    dispatch(cleareditUserPermission());
  }, []);

  useEffect(() => {
    const roleId = searchParams.get("id");
    const yearId = searchParams.get("year");

    // Build payload dynamically
    const payload: {
      roleId?: number;
      year_group_id?: number;
    } = {};

    if (roleId) payload.roleId = Number(roleId);
    if (yearId) payload.year_group_id = Number(yearId);

    // Call API if at least one filter exists
    if (Object.keys(payload).length > 0) {
      dispatch(userPermissionRowsList(payload));
    }
  }, [dispatch, searchParams]);

  // ?.filter((role) => role.name !== "ADMIN") // Filter out roles where status is false

  const filteredRole = permissionData.data?.data?.map((role) => ({
    value: role.id,
    label: role.name!,
    status: role.status,
  })) ?? [];

  const Yearlist = listYearlevel_maps?.data || [];
  const YearOptions = Array.isArray(Yearlist)
    ? Yearlist.map((item: any) => ({
        label: item.yeargroup.name,
        value: item.id,
      }))
    : [];

  const rows = userPermissionRowsData.data?.data?.map((row) => ({
    ...row,
    menu_id: row.menu_id ?? row.id,
    add: !!row.add,
    edit: !!row.edit,
    delete: !!row.delete,
    view: !!row.view,
  }));

  console.log("roes to menu", rows);

  console.log("userPermissionRowsData to menu", userPermissionRowsData);

  return (
    <>
      <Snackbar response={userPermissionRowsDataUpdate.data} />
      <UserPermission
        rows={rows ?? []}
        RoleOptions={filteredRole ?? []}
        YearOptions={YearOptions ?? []}
        getRoleValues={(val) => console.log(val)}
        getRoleOption={(val) => {
          dispatch(userPermissionRowsList(val?.value));
        }}
      />
    </>
  );
};

export default UserPermissions;
